import React from "react";
import { LanguageEnum } from "../types";

type LanguageToggleProps = {
  value: LanguageEnum;
  onChange: (language: "japanese" | "english") => void;
};

// 日本語 / EN の切り替え（見出し「言語設定」付き）。検索画面とカード表示画面で使う
const LanguageToggle: React.FC<LanguageToggleProps> = ({ value, onChange }) => (
  <div>
    <span className="c-label" id="lang-label">言語設定</span>
    <div className="langToggle" role="group" aria-labelledby="lang-label">
      <button type="button" className={`langToggle__option${value === "japanese" ? " is-active" : ""}`} onClick={() => onChange("japanese")}>
        日本語
      </button>
      <button type="button" className={`langToggle__option${value === "english" ? " is-active" : ""}`} onClick={() => onChange("english")}>
        EN
      </button>
      <div className={`langToggle__slider${value === "english" ? " is-right" : ""}`} />
    </div>
  </div>
);

export default LanguageToggle;
